import React, { useContext } from "react";
import styles from "./ToggleThemeButton.module.scss";

import { FaSun, FaMoon } from "react-icons/fa";

import { ThemeContext } from "../../../context/ThemeContext";

const DarkModeToggle = () => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const isDark = theme === "dark";
  
    return (
      <button
        className={styles.toggleBtn}
        onClick={toggleTheme}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        type="button"
        style={{ color: isDark ? "#ffffff" : "#f5a623" }}
      >
        {isDark ? <FaMoon /> : <FaSun />}
      </button>
    );
  };

export default DarkModeToggle;
